import { FETCH_GOLF_PROFILE, FETCH_GOLF_PROFILE_SUCCESS, FETCH_GOLF_PROFILE_FAIL } from 'actions/golfProfileActions.js';

// Used for updates/saves
export const NETWORKING_STATUSES = {
    FAIL: 'FAIL',
    SUCCESS: 'SUCCESS',
    FETCHING: 'FETCHING'
};

const INITIAL_STATE = {
    golfProfiles: {},
    networkingStatus: NETWORKING_STATUSES.SUCCESS
};

const fetchGolfProfileSuccess = (state, action) => {
    return {
        golfProfiles: {
            ...state.golfProfiles,
            [action.displayName]: action.golfProfile
        },
        networkingStatus: NETWORKING_STATUSES.SUCCESS
    };
};

const fetchGolfProfileStart = (state, action) => {
    return {
        golfProfiles: {
            ...state.golfProfiles
        },
        networkingStatus: NETWORKING_STATUSES.FETCHING
    };
};

const fetchGolfProfileFail = (state, action) => {
    return state;
};

const handlers = {
    [FETCH_GOLF_PROFILE_SUCCESS]: fetchGolfProfileSuccess,
    [FETCH_GOLF_PROFILE]: fetchGolfProfileStart,
    [FETCH_GOLF_PROFILE_FAIL]: fetchGolfProfileFail
};

export default function golfProfile(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchGolfProfile(displayName, evictCache) {
    return {
        type: FETCH_GOLF_PROFILE,
        displayName: displayName,
        meta: {
            cacheTime: evictCache ? null : 60000
        }
    };
}

// Getters
export const getGolfProfiles = (state) => {
    const keys = Object.keys(state.golfProfile.golfProfiles);
    const golfProfiles = keys.map((key) => state.golfProfile.golfProfiles[key]);
    return golfProfiles;
};

export const getGolfProfile = (state, displayName) => {
    return state.golfProfile.golfProfiles[displayName] || {};
};

export const getGolfProfileNetworkStatus = (state) => {
    return state.golfProfile.networkingStatus;
};
